export type ReportPopulationState = {
  includeTestRows: boolean;
  includeInactiveEpisodes: boolean;
  includeImportedPatients?: boolean;
};

export function buildReportPopulationQuery({
  includeTestRows,
  includeInactiveEpisodes,
  includeImportedPatients,
}: ReportPopulationState) {
  return {
    include_test_rows: includeTestRows,
    include_inactive_episodes: includeInactiveEpisodes,
    ...(includeImportedPatients !== undefined
      ? { include_imported_patients: includeImportedPatients }
      : {}),
  };
}
